import { Component, OnInit, ViewChild } from '@angular/core';
import { CustomersService, FindCustomerResult, VehiclesService, BookingModel } from 'src/app/Api_Module';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { Router } from '@angular/router';

@Component({
  selector: 'crg-customers',
  templateUrl: './customers.component.html'
})
export class CustomersComponent implements OnInit {

  @ViewChild('customersTable')
  private table: DatatableComponent;

  searchType = 'car';

  searchStr: string;

  loadingVehicles: boolean;
  loadingSearch: boolean;
  loadingBookings: boolean;

  selectedCustomers: FindCustomerResult[] = [];
  selectedVeh: FindCustomerResult[] = [];
  selectedCustomer: FindCustomerResult;
  selectedVehicle= false;

  customers: FindCustomerResult[] = [];

  vehicles: any[] = [];
  bookings:BookingModel[]=[];

  messagesC = {emptyMessage: 'No Customers found. Try different parameters', totalMessage: 'Total Customer'};

  messagesV = {emptyMessage: 'No Vehicles found. Try different parameters', totalMessage: 'Total Vehicles'};
  messagesB = {emptyMessage: 'No Bookings found.', totalMessage: 'Total Bookings'};

  constructor(private customersService: CustomersService, private vehiclesService: VehiclesService,
     private toastr: ToastrService, public authSrvc: AuthenticationService, private router:Router ) { }

  ngOnInit() {
  }

  searchCustomers(searchStr?: string) {
    this.vehicles = [];
    this.selectedCustomer = {};
    if (!!searchStr) {
      this.searchStr = searchStr;
    }
    this.loadingSearch = true;
    // tslint:disable-next-line:max-line-length
    this.customersService.find(!!this.searchStr && this.searchStr.trim ? this.searchStr.trim() : this.searchStr).subscribe((resp: FindCustomerResult[])  => {
      this.loadingSearch = false;
      this.customers = resp;
    },
      error => {
        this.loadingSearch = false;
        if (error['status'] === 404) {
          this.toastr.warning('Customer Not Found!');
        } else {
          this.toastr.error('Something went wrong please try again later!');
        }
        console.log('error:' + JSON.stringify(error));
      });
  }

  toggleExpandRow(row) {
    console.log('Toggled Expand Row!', row);
    this.table.rowDetail.toggleExpandRow(row);
  }

  onSelect(custObj: any) {
    this.bookings =[];
    this.loadingVehicles = true;
    const customerId = custObj.selected[0].id;
    this.selectedCustomer = custObj.selected[0];
    this.getBookings(custObj);
    this.customersService.get(customerId).subscribe((resp: FindCustomerResult)  => {
      this.loadingVehicles = false;
      this.vehicles = [... resp.cars];
    },
      error => {
        this.loadingVehicles = false;
        if (error['status'] === 404) {
          this.toastr.warning('Vehicle(s) Not Found!');
        } else {
          this.toastr.error('Something went wrong please try again later!');
        }
        console.log('error:' + JSON.stringify(error));
      });
  }
  getBookings(customer){
    this.selectedVehicle = true;
   this.loadingBookings = true;
   this.customersService.bookings(customer.selected[0].id).subscribe((resp:BookingModel[])=>{
      this.loadingBookings=false;
      this.bookings =[... resp];
   });
  }

  deleteCustomer(customerId) {
    this.loadingSearch = true;
    this.toastr.warning('Not Impletement Yet');
    this.loadingSearch = false;
  }

  deleteVehicle(vehId) {
    this.loadingVehicles = true;
    this.toastr.warning('Not Impletement Yet');
    this.loadingVehicles = false;
  }

  onSelectBooking(vehObj: any) {
    const ref = vehObj.selected[0].reference;
    this.router.navigate([ 'search/bookings' ], {queryParams: {query: ref}});
  }

  close(alert: any) {
    // this.alert = null;
  }
}
